export default __webpack_public_path__ + "static/media/onboardingAsideMb.7979c832.png";